import {Box} from "@mui/system";
import {useDispatch} from "react-redux";
import ActionButton from "../../../common/ActionButton";
import {submitAction} from "../Utilities/UserInviteUtils";

export default function UserInviteActionContainer({handleClose, userInvite, actionType}) {
    const dispatch = useDispatch();
    const selectedActionType = actionType?.id;

    const performAction = () => {
        submitAction(dispatch, userInvite, selectedActionType);
        handleClose();
    };

    return(
        <Box>
            <Box sx={styles.description}>
                {actionType?.description}
            </Box>

            <Box sx={styles.buttonContainer}>
                <Box sx={styles.cancelButtonContainer}>
                    <ActionButton
                        label={'Cancel'}
                        action={handleClose}
                        buttonBordered
                        useBorderColor={'#003300'}
                        withIcon={false}
                        sx={styles.cancelButton}
                        type={'button'}
                    />
                </Box>
                <Box>
                    <ActionButton
                        label={actionType?.name}
                        action={performAction}
                        withIcon={false}
                        sx={styles.sendButton}
                    />
                </Box>
            </Box>
        </Box>
    )
}

const styles = {
    inputDesc: {
        fontFamily: 'LarsseitMedium',
        fontSize: '14px',
        fontWeight: 500,
        color: '#495D5E',
        mb: '5px',
    },
    body: {
        fontFamily: 'larsseitRegular',
        fontSize: '16px',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '15px',
    },
    cancelButtonContainer: {
        width: '84px',
        marginRight: '15px',
    },
    cancelButton: {
        height: '35px',
    },
    sendButton: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    description: {
        fontFamily: 'LarsseitRegular',
        fontSize: '16px',
        color: '#0C2728',
        letterSpacing: '-0.01em',
        marginBottom: '12px'
    },
};